import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { BASE_URL } from "../../config/axios";
import { AddwithWhiteCircle, Attachment } from "../AllSvg";
import { Modal } from "react-bootstrap";
import { handleErrorToast } from "../CustomFunctions";
const DeleteDocument = ({ i, getData }) => {
    const [show, setShow] = useState(false);
    // console.log(i)
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    console.log("documentData")
    console.log(i)

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/detail-design/subactivitydocumentputdelete/${i.id}/`
            );

            if (res.status === 200) {
                await getData();
                setShow(false);
            } else {

            }
        } catch (err) {
            // setShow(false);
            toast.error(err)
            handleErrorToast(err)
        } finally {
            // setLoading(false); //loading logic
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete"
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Document {i.document_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete document ({i.document_name})
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500  model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};

const DocumentModel = ({ projectiD, subactivityId, activityId, title }) => {
    const [show, setShow] = useState(false);
    const [toggleState, setToggleState] = useState(1);
    const [formData, setFormData] = useState([
        {
            document_name: "",
            document_file: null,
            activity: activityId ? activityId : "",
            project: projectiD ? projectiD : "null",
            subactivity: subactivityId ? subactivityId : "",

        },
    ]);







    const [uploadProgress, setUploadProgress] = useState(0);
    const [loading, setLoading] = useState(false);
    const fileInputRefs = useRef([]);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        setFormData([
            {
                document_name: "",
                document_file: null,
                activity: activityId || "",
                project: projectiD || "null",
                subactivity: subactivityId || "",


            },
        ]);
    }, [activityId, subactivityId]);





    const refresh = () => {
        setFormData(
            [{
                document_name: "",
                document_file: "",
                activity: activityId ? activityId : "",
                project: projectiD ? projectiD : "null",
                subactivity: subactivityId ? subactivityId : "",

            },]
        )
    }
    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);

        setToggleState(1);
        refresh();
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => {
            const newDocuments = [...prevFormData];
            newDocuments[index] = {
                ...newDocuments[index],
                [name]: value,
            };
            return newDocuments;
        });

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (value.trim() !== "") {
                delete newErrors[`${index}-${name}`];
            }
            return newErrors;
        });
    };


    const handleFileChange = (e, index) => {
        const file = e.target.files[0];

        if (file) {
            const allowedTypes = [
                "application/pdf",
                "application/png",
                "application/gif",
                "application/zip", "application/x-zip-compressed",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel"
            ];

            if (!allowedTypes.includes(file.type) && !file.name.match(/\.(zip|pdf|xls|xlsx|png|gif)$/)) {
                toast.error("Only ZIP, PDF, GIF and Excel files are allowed!");
                return;
            }

            setFormData((prevFormData) => {
                const newDocuments = [...prevFormData];
                newDocuments[index] = {
                    ...newDocuments[index],
                    document_file: file,
                };
                return newDocuments;
            });

            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors[`${index}-document_file`];
                return newErrors;
            });
        }
    };




    const addNewDocument = () => {
        setFormData((prevFormData) => [
            ...prevFormData,
            {
                document_name: "",
                document_file: null,
                activity: activityId || "",
                project: projectiD || "",
                subactivity: subactivityId || "",
            },
        ]);
        fileInputRefs.current.push(null);
    };


    const handleRemoveDocument = (index) => {
        setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
        fileInputRefs.current.splice(index, 1);
    };

    const handleClear = (index) => {
        setFormData((prevFormData) => {
            const newDocuments = [...prevFormData];
            newDocuments[index] = {
                ...newDocuments[index],
                document_file: null,
            };
            return newDocuments;
        });

        if (fileInputRefs.current[index]) {
            fileInputRefs.current[index].value = "";
        }
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[`${index}-document_file`];
            return newErrors;
        });
    };

    const validateForm = () => {
        const newErrors = {};

        formData.forEach((doc, index) => {

            if (!doc.document_name.trim()) {
                newErrors[`${index}-document_name`] = "Document Name is required!";
            }
            if (!doc.document_file) {
                newErrors[`${index}-document_file`] = "Document file is required!";
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");

            const formDataToSend = new FormData();




            for (let [index, doc] of formData.entries()) {
                formDataToSend.append(`documents[${index}][document_name]`, doc.document_name);

                if (doc.document_file) {
                    formDataToSend.append(`documents[${index}][document_file]`, doc.document_file);
                }

                if (doc.activity) {
                    formDataToSend.append(`documents[${index}][activity]`, doc.activity);
                }
                if (doc.project) {
                    formDataToSend.append(`documents[${index}][project]`, doc.project);
                }
                if (doc.subactivity) {
                    formDataToSend.append(`documents[${index}][subactivity]`, doc.subactivity);
                }
            }


            try {
                const response = await axios.post(
                    `${BASE_URL}/detail-design/bulksubactivity/`,
                    formDataToSend,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                if (response.status === 201) {
                    getDocuments();
                    setToggleState(2);
                    refresh();

                    toast.dismiss(loadingToastId);
                    toast.success("Document added successfully!");

                }

            } catch (error) {


            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);

                setUploadProgress(0);
            }
        }
    };

    const [DocumentData, setDocumentData] = useState([]);
    const getDocuments = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/detail-design/documentfilter/${subactivityId ? subactivityId : "null"}/${activityId ? activityId : "null"}/${projectiD}/`)
            setDocumentData(res.data)
        } catch (error) {
            console.error(error);

        }
    }

    useEffect(() => {
        getDocuments();
    }, [activityId, subactivityId, projectiD])


    console.log("formData")
    console.log(formData)



    return (



        <>
            <>
                <button title="Add/View Document" className="document-download-button  width-10vw " onClick={handleShow}>
                    Add/View
                </button>
            </>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title>

                        {toggleState === 1 ? `Add ${title}` : `View ${title}`}



                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="bloc-tabss wfm-marginn flex-row justify-between">
                        <div>
                            <button
                                className={
                                    toggleState === 1
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                                }
                                onClick={() => setToggleState(1)}
                            >
                                Add {title}
                            </button>

                            <button
                                className={
                                    toggleState === 2
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                                }
                                onClick={() => setToggleState(2)}
                            >
                                View {title}
                            </button>
                        </div>




                    </div>

                    {toggleState === 1 &&
                        <div className="flex-row justify-end">
                            <button onClick={addNewDocument} className="upload-svg ">
                                <AddwithWhiteCircle />
                                {" "} Another Document
                            </button>
                        </div>

                    }
                    <div className="content-tabs">
                        {
                            toggleState === 1 ?
                                <>
                                    {formData.map((data, index) => (
                                        <div className="flex-row justify-between" key={index}>
                                            <div className="flex-column">
                                                <label htmlFor="document_name" className="form-labels font-weight500 font-size-subheading">
                                                    Document Name<span className="required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="document_name"
                                                    value={data.document_name}
                                                    onChange={(e) => handleInputChange(e, index)}
                                                    placeholder="Document Name"
                                                    className="form-input width-15vw"
                                                />
                                                {errors[`${index}-document_name`] && (
                                                    <span className="error-message font-size-text">
                                                        {errors[`${index}-document_name`]}
                                                    </span>
                                                )}
                                            </div>

                                            <div className="upload-button-field">
                                                <div title="Upload Document" className="flex-column">
                                                    <label htmlFor={`document_file_${index}`} className="form-labels font-weight500 font-size-subheading">
                                                        Upload Document<span className="required">*</span>
                                                    </label>
                                                    <div className="flex-row justify-between">
                                                        <div >
                                                            <label htmlFor={`document_file_${index}`} className="svg-icon">
                                                                <div className="svg-field form-input align-center">
                                                                    <Attachment />
                                                                </div>

                                                            </label>
                                                            <input
                                                                type="file"
                                                                id={`document_file_${index}`}
                                                                name="document_file"
                                                                accept=".zip, .pdf, .xls, .xlsx, .gif"
                                                                style={{ display: "none" }}
                                                                onChange={(e) => handleFileChange(e, index)}
                                                                ref={(el) => (fileInputRefs.current[index] = el)}
                                                            />
                                                        </div>
                                                        <div style={{ width: "6vw" }}>
                                                            {data.document_file && (
                                                                <span className="file-name">
                                                                    {data.document_file.name}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="flex-row justify-between" style={{ width: "12vw" }}>
                                                            <button title="Clear File" onClick={() => handleClear(index)} className="file-clear clear-button">
                                                                Clear
                                                            </button>
                                                            {formData.length > 1 && (
                                                                <button title="Remove Document" onClick={() => handleRemoveDocument(index)} className="file-clear clear-button">
                                                                    Remove
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {errors[`${index}-document_file`] && (
                                                        <span className="error-message font-size-text">
                                                            {errors[`${index}-document_file`]}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {uploadProgress > 0 && (
                                        <div className="progress-bar">
                                            <h6 className="uploading-percentage">Uploading {uploadProgress}%</h6>
                                            <div className="progress-bar-fill" style={{ width: `${uploadProgress}%` }}></div>

                                        </div>
                                    )}

                                    <div className="button-models">
                                        <button
                                            className="model-button font-weight500 model-button-cancel"
                                            onClick={handleClose}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleSubmit}
                                            className="model-button font-weight500 model-button-submit"
                                            disabled={loading}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </> :
                                <>

                                    <div className='table-overflow'>

                                        <table className="table-css">
                                            <thead>
                                                <tr className="custom-table-head-tr ">
                                                    <th className="table-heading-text">S.No.</th>
                                                    <th className="table-heading-text">Document Name</th>

                                                    <th className="table-heading-text text-center">Document</th>
                                                    <th className="table-heading-text text-right">Action</th>
                                                </tr>
                                            </thead>

                                            <tbody
                                            >

                                                {activityId && (
                                                    DocumentData
                                                        .map((doc, docIndex) => (
                                                            <React.Fragment key={docIndex}>
                                                                <tr className="custom-table-head-td">
                                                                    <td className="table-body">{docIndex + 1}.</td>
                                                                    <td className="table-body">{doc.document_name}</td>
                                                                    <td className="table-body text-center">
                                                                        {doc.document_file ? (



                                                                            <a href={doc.document_file} className="menu__link " style={{ textAlign: "center" }} target="blank">
                                                                                View
                                                                            </a>
                                                                        ) : (
                                                                            "Document Not Attached"
                                                                        )}
                                                                    </td>
                                                                    <td className="table-body">
                                                                        <DeleteDocument i={doc} getData={getDocuments} />
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>

                                                        ))
                                                )}
                                                {subactivityId && (
                                                    DocumentData
                                                        .map((doc, docIndex) => (
                                                            <React.Fragment key={docIndex}>
                                                                <tr className="custom-table-head-td">
                                                                    <td className="table-body">{docIndex + 1}.</td>
                                                                    <td className="table-body">{doc.document_name}</td>
                                                                    <td className="table-body text-center">
                                                                        {doc.document_file ? (



                                                                            <a href={doc.document_file} className="menu__link " style={{ textAlign: "center" }} target="blank">
                                                                                View
                                                                            </a>
                                                                        ) : (
                                                                            "Document Not Attached"
                                                                        )}
                                                                    </td>
                                                                    <td className="table-body">
                                                                        <DeleteDocument i={doc} getData={getDocuments} />
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>

                                                        ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                        }
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal >

        </>


    );
};


export { DocumentModel }